//@flow

import React from 'react';
import type { Cryptocurrency } from '@tectonics/commons/cryptocurrency/cryptocurrencies/cryptocurrency-type';
import UsdcIcon from './usdc-icon';
import {erc20} from '@tectonics/commons/cryptocurrency/protocol/erc20/erc20';
import { bep20 } from '@tectonics/commons/cryptocurrency/protocol/bep20/bep20';
import {polygon} from '@tectonics/commons/cryptocurrency/protocol/polygon/polygon';
import {sol} from '@tectonics/commons/cryptocurrency/protocol/sol/sol';

export const usdc: Cryptocurrency = {
  code: 'usdc',
  icon: <UsdcIcon alt ="usdc icon"/>,
  abbreviation: 'USDC',
  name: 'USDC (USD Coin)',
  protocols: [erc20, bep20, polygon, sol],
};
